import { FrustumVisualizer } from './FrustumVisualizer.js';
import { Color4 as BABYLON_Color4 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.color.js';
import { LineType } from '../../../api.js';
export class CameraFrustumVisualizer extends FrustumVisualizer {
    constructor(_camera, viewer, color = new BABYLON_Color4(1), line_thickness = 0.05, line_type = LineType.SOLID) {
        super(viewer, color, line_thickness, line_type);
        this._camera = _camera;
        this.update();
    }
    update() {
        if (this._camera.viewer.get_active_camera() === this._camera) {
            this.remove_lines(0);
            return;
        }
        super.update();
    }
    get_matrices_ref(ref_view, ref_projection) {
        ref_view.fromIMatrix4(this._camera.view_matrix);
        ref_projection.fromIMatrix4(this._camera.projection.get_projection_matrix());
        return true;
    }
}
//# sourceMappingURL=CameraFrustumVisualizer.js.map